import { defineStyleConfig } from "@chakra-ui/react";

export const Container = defineStyleConfig({
  variants: {
    primary: {
      w: "90%",
      maxW: "1280px",
    },
  },
});
